import { jsxs as f, jsx as a } from "react/jsx-runtime";
import { u as c } from "./index-6a632112.mjs";
import { s as r, c as e, r as s } from "./themes-5f0b3c3d.mjs";
import "react";
import { S as x } from "./checkmark-84b5274e.mjs";
import { useAccessibilityProps as g } from "./accessibility.js";
import "./types-b577bf77.mjs";
const d = "18px", $ = "2px", w = c.div`
  ${({ $size: t }) => {
  if (t === "large")
    return `
    height: ${r["8x"]};
    width: ${r["14x"]};
            `;
  if (t === "medium")
    return `
    height: ${r["7x"]};
    width: ${r["12x"]};
            `;
}}
  ${({ $isChecked: t, $isDisabled: i }) => {
  if (t && !i)
    return `background-color: ${e.accentBlue[1e3]};`;
  if (!t && !i)
    return `background-color: ${e.brandTwilight[600]};`;
  if (i)
    return `background-color: ${e.brandTwilight[400]};`;
}}

  border-radius: ${d};
  position: relative;
  transition: background-color 150ms linear;
  &:focus-within {
    outline-offset: ${r["1x"]};
    outline-color: ${e.accentBlue[1e3]};
    outline-style: solid;
    outline-width: ${$};
    border-radius: ${d};
  }
`, b = c.input`
  position: absolute;
  height: 100%;
  width: 100%;
  z-index: 10;
  top: 0;
  left: 0;
  opacity: 0;
  cursor: pointer;
  margin: 0;

  &:disabled {
    cursor: default;
  }
`, y = c.div`
  position: absolute;
  height: 100%;
  width: 100%;
`, k = c.span`
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  margin: ${r["1x"]};
  background-color: ${e.brandTwilight[0]};
  transition: margin 150ms linear;
  ${({ $size: t }) => {
  if (t === "large")
    return `
        height: ${r["6x"]};
        width: ${r["6x"]};
        border-radius: ${s["6x"]};
        `;
  if (t === "medium")
    return `
        height: ${r["5x"]};
        width: ${r["5x"]};
        border-radius: ${s["5x"]};
        `;
}}

  ${({ $isChecked: t, $size: i }) => {
  if (t && i === "large")
    return `margin-left: ${r["7x"]};`;
  if (t && i === "medium")
    return `margin-left: ${r["6x"]};`;
}}
`;
function R({
  size: t = "medium",
  isDisabled: i = !1,
  isChecked: o = !1,
  onChange: u,
  dataTestIdProps: l,
  accessibilityOptions: h = { ariaLabel: "toggle switch" }
}) {
  const m = g("switch", {
    ariaChecked: o,
    ariaDisabled: i,
    ...h
  }), p = (n) => {
    if (n.key === " " || n.key === "Enter") {
      if (n.preventDefault(), i)
        return;
      u && u(n);
    }
  };
  return /* @__PURE__ */ f(
    w,
    {
      $size: t,
      $isChecked: o,
      $isDisabled: i,
      "data-testid": l?.wrapperTestId || "switch",
      children: [
        /* @__PURE__ */ a(
          b,
          {
            type: "checkbox",
            disabled: i,
            checked: o,
            onChange: u,
            onKeyDown: p,
            ...m,
            "data-testid": l?.inputTestid || "checkbox"
          }
        ),
        /* @__PURE__ */ a(y, { children: /* @__PURE__ */ a(k, { $size: t, $isChecked: o, children: o && /* @__PURE__ */ a(
          x,
          {
            width: t === "medium" ? r["4x"] : r["5x"],
            height: t === "medium" ? r["4x"] : r["5x"],
            color: e.accentBlue[1e3]
          }
        ) }) })
      ]
    }
  );
}
export {
  R as Switch
};
